import { useState } from 'react';
import { faqs } from '@/mocks/siteData';
import SectionHeading from '@/components/feature/SectionHeading';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-background-100" aria-labelledby="faq-title">
      <div className="w-full px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="常见问题"
          title="吃瓜前，先看这几个问题"
          description="关于内容来源、人物代称和投稿方式，我们把最常被问到的几点整理在这里。"
        />
        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.q}
                className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-primary-50"
                  >
                    <span className="font-heading text-base font-semibold text-foreground-950">{faq.q}</span>
                    <i
                      className={`shrink-0 text-xl text-primary-600 ${
                        isOpen ? 'ri-subtract-line' : 'ri-add-line'
                      }`}
                    ></i>
                  </button>
                </h3>
                {isOpen && (
                  <p className="border-t border-background-200 px-5 py-4 font-body text-sm leading-relaxed text-foreground-600">
                    {faq.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}